import { Modal } from '../bootstrap';

export class ChangelogModal {
  static start() {
    $('#papi_version').on('click', ChangelogModal.open_modal);
  }

  static open_modal() {
    $.get('/docs/changelog/modal', (data) => {
      const $body = $(document.body);
      const $modal = $(data);

      $body.append($modal);

      const modal = new Modal($modal[0]);

      $modal.on('hidden.bs.modal', () => {
        modal.modal('dispose');
        $modal.remove();
      });

      modal.show();
    });
  }
}
